import { combineReducers } from 'redux';
import boardIssueMoveDialogReducer from './board-issue-move-dialog/reducer';
import cardListReducer from './card-list/reducer';
import cardsReducer from './cards/reducer';
import { detailViewReducer } from './detail-view/reducer';
import dragReducer from './drag/reducer';
import filtersReducer from './filters/reducer';
import isConfigLoadedReducer from './is-config-loaded/reducer';
import isCriticalDataLoadedReducer from './is-critical-data-loaded/reducer';
import issueTransitionModalReducer from './issue-transition/reducer';
import { modalsReducer } from './modals/reducer';
import panelReducer from './panels/reducer';
import type { UiState } from './types';
import workloadModalReducer from './workload-modal/reducer';

export default combineReducers<UiState>({
	boardIssueMoveDialog: boardIssueMoveDialogReducer,
	cardList: cardListReducer,
	cards: cardsReducer,
	detailView: detailViewReducer,
	issueTransitionModal: issueTransitionModalReducer,
	filters: filtersReducer,
	panels: panelReducer,
	isConfigLoaded: isConfigLoadedReducer,
	isCriticalDataLoaded: isCriticalDataLoadedReducer,
	modals: modalsReducer,
	drag: dragReducer,
	workloadModal: workloadModalReducer,
});
